<template>
  <div :class="question.type != 1000 && question.type != 10001 && question.type != 1 && question.type != 2 ? 'draggable-item' : 'draggable-item2'">
    <div class="question-border">
      <div class="question-q " :class="{ poll: mainType == 7, disabled: question.disableIsRequired && question.type != 500, passive: !question.isActive }">
        <div class="question-head-2">
          <i v-if="loading == question.id || active" class="el-icon-loading text-info question-save left-icon"></i>
          <i v-else class="el-icon-s-grid left-icon" :class="question.type != 1000 && question.type != 10001 && question.type != 1 && question.type != 2 ? 'movable' : ''"></i>
          <div class="error-container" @keydown="lastFocus = question.id">
            <el-input v-model="question.title" :class="{ 'error-input': getQuestionsValidation.some(x => x.key.includes(question.id)) }"></el-input>
            <span class="error">{{ $errorMessage(question.id + "-Title", getQuestionsValidation) }}</span>
          </div>
        </div>

        <div class="question-type" v-if="mainType != 7">{{ getEnumsDisplay("RegistrationInputType", question.type) }}</div>
        <div class="text-center" v-if="mainType != 7"><el-checkbox v-model="question.isRequired" @change="lastFocus = question.id" :disabled="question.disableIsRequired" :checked="question.isRequired" :indeterminate="question.packetLimitations.some(x => x.type == 1)"></el-checkbox></div>
        <div class="text-center" v-if="mainType != 7"><el-switch v-model="question.isActive" @change="lastFocus = question.id" :disabled="question.disableIsActive" :checked="question.isActive"></el-switch></div>
        <div class="question-head-btn" v-if="mainType != 7">
          <el-tooltip placement="top" slot="reference" :content="$t('components.registerForm.recursiveQuestion.editQuestion')">
            <!-- <div slot="content">Edit Question</div> -->
            <el-button size="small" circle type="success" icon="fas fa-pen" v-if="question.disableUpdate == false" @click="openQuestionEditDialog(question)"></el-button>
          </el-tooltip>
          <el-popconfirm :title="$t('components.registerForm.recursiveQuestion.deleteSure')" @confirm="deleteQuestionOne(question.id)" :confirm-button-text="$t('components.registerForm.recursiveQuestion.yes')" :cancel-button-text="$t('components.registerForm.recursiveQuestion.cancel')">
            <el-tooltip placement="top" slot="reference" :content="$t('components.registerForm.recursiveQuestion.deleteQuestion')">
              <!-- <div slot="content">Delete Question</div> -->
              <el-button size="small" circle type="danger" icon="fas fa-trash" v-if="question.disableDelete == false"></el-button>
            </el-tooltip>
          </el-popconfirm>
          <el-popconfirm :title="$t('components.registerForm.recursiveQuestion.copySure')" @confirm="copyQuestionOne(question.id)" v-if="question.type == 15 || question.type == 16 || question.type == 100" :confirm-button-text="$t('components.registerForm.recursiveQuestion.yes')" :cancel-button-text="$t('components.registerForm.recursiveQuestion.cancel')">
            <el-tooltip placement="top" slot="reference" :content="$t('components.registerForm.recursiveQuestion.copyQuestion')">
              <!-- <div slot="content">Delete Question</div> -->
              <el-button size="small" circle type="warning" :loading="loading == 'copyItem-' + question.id" icon="fas fa-copy"></el-button>
            </el-tooltip>
          </el-popconfirm>
        </div>
      </div>
      <template v-if="question.type == 15 || question.type == 16 || question.type == 100">
        <draggable :list="question.options" tag="div" class="list-group-o" :group="question.id" v-bind="dragOptions" :move="checkMove">
          <div class="question-q-2 pl-4" v-for="(option, index) in question.options" :key="index + question.id">
            <div class="question-q-3 ">
              <div class="question-head-2" @keydown="lastFocus = option.id">
                <i :class="getLastFocusLoading == true ? (lastFocus == option.id && activeIndex == index ? 'el-icon-loading text-info question-save left-icon' : 'el-icon-s-grid movable left-icon') : 'el-icon-s-grid movable left-icon'"></i>

                <div class="error-container w-100">
                  <el-input v-model="option.title" :class="{ 'error-input': getQuestionsValidation.some(x => x.key == option.id + '-Title') }" class="w-100"></el-input>
                  <span class="error">{{ $errorMessage(question.id + "--" + option.id + "Title", getQuestionsValidation) }}</span>
                </div>
                <div class="error-container w-100" v-if="true && (mainType == 0 || mainType == 1 || mainType == 3 || mainType == 6)">
                  <MoneyInput :min="-99999" :max="99999" :fixed="2" v-model="option.price" clearable>
                    <template slot="append">{{ getEnumsDisplay("Currency", currentForm.paymentInfo.currency) }}</template>
                  </MoneyInput>
                  <span class="error">{{ $errorMessage(question.id + "--" + option.id + "Price", getQuestionsValidation) }}</span>
                </div>
                <div class="error-container w-100">
                  <el-select v-model="option.tagIds" clearable @clear="option.tagIds = []" :placeholder="$t('eventPageTitle.segmentation')" multiple filterable>
                    <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag.id">
                      <template>
                        <i class="fas fa-circle mr-2" :style="{ color: tag.color }"></i>
                        <span>{{ tag.title }}</span>
                      </template>
                    </el-option>
                  </el-select>
                  <span class="error">{{ $errorMessage(question.id + "--" + option.id + "Title", getQuestionsValidation) }}</span>
                </div>
              </div>
              <div class="question-head-btn">
                <el-tooltip placement="top" :content="$t('components.registerForm.recursiveQuestion.addSubQuestion')" v-if="mainType != 7">
                  <!-- <div slot="content">Add Sub Question</div> -->
                  <el-button size="small" circle icon="fas fa-plus" type="primary" @click="addNewQuestion(option.id)"></el-button>
                </el-tooltip>
                <el-tooltip placement="top" slot="reference" :content="$t('components.registerForm.recursiveQuestion.deleteOption')" v-if="question.options.length > 2">
                  <!-- <div slot="content">Delete Option</div> -->
                  <el-popconfirm :title="$t('components.registerForm.recursiveQuestion.deleteSure')" @confirm="question.options.splice(index, 1)">
                    <el-button size="small" circle icon="fas fa-trash" slot="reference" type="danger"></el-button>
                  </el-popconfirm>
                </el-tooltip>
                <el-tooltip placement="top" slot="reference" :content="$t('components.registerForm.recursiveQuestion.discardSubQuestion')" v-if="mainType != 7">
                  <!-- <div slot="content">Discard Sub Questions</div> -->
                  <el-popconfirm :title="$t('components.registerForm.recursiveQuestion.deleteSure')" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" @confirm="deleteSubQuestion(option.id)">
                    <el-button size="small" slot="reference" circle icon="el-icon-minus" type="warning" v-if="currentQuestions.filter(x => x.parentAnswerId == option.id)"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </div>
            </div>
            <el-collapse accordion class="mb-3" v-if="currentQuestions.some(x => x.parentAnswerId == option.id)">
              <el-collapse-item :name="option.id">
                <template slot="title">
                  <div class="collapsed-title">{{ totalSub(option.id) }} {{ $t("components.registerForm.recursiveQuestion.questions") }}, {{ totalOptions(option.id) }} {{ $t("components.registerForm.recursiveQuestion.options") }}</div>
                  <div class="expand-container">{{ $t("components.registerForm.recursiveQuestion.expand") }}</div>
                  <div class="collapse-container">{{ $t("components.registerForm.recursiveQuestion.collapse") }}</div>
                </template>
                <div class="question-head" v-if="currentQuestions.some(x => x.parentAnswerId == option.id)">
                  <div>{{ $t("components.registerForm.recursiveQuestion.label") }}</div>
                  <div>{{ $t("components.registerForm.recursiveQuestion.questionType") }}</div>
                  <div class="text-center">{{ $t("components.registerForm.recursiveQuestion.required") }}</div>
                  <div class="text-center">{{ $t("components.registerForm.recursiveQuestion.show") }}</div>
                  <div></div>
                </div>
                <draggable :list="currentQuestions" tag="div" handle=".movable" class="list-group-o" :group="question.id + '-option'" v-bind="dragOptions" :move="checkMove">
                  <div v-for="(quest, questionIndex) in currentQuestions" :key="quest.id + questionIndex">
                    <RecursiveQuestion :mainType="mainType" :baseId="baseId" :active="activeIndex == questionIndex" :saveStatus="saveStatus" :question="quest" v-if="quest.parentAnswerId == option.id"></RecursiveQuestion>
                  </div>
                </draggable>
                <div class="addQuestionButtonRow" v-if="currentQuestions.some(x => x.parentAnswerId == option.id)">
                  <el-button icon="fas fa-plus" type="primary" round size="small" @click="addNewQuestion(option.id)">{{ $t("components.registerForm.recursiveQuestion.addQuestion") }}</el-button>
                  <b>{{ option.title }}</b>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </draggable>
      </template>

      <div class="addOptionButtonRow pl-4" v-if="question.type == 15 || question.type == 16 || question.type == 100">
        <el-button icon="fas fa-plus" type="primary" round size="small" @click="AddOption">{{ $t("components.registerForm.recursiveQuestion.addOption") }}</el-button>
        <b>{{ question.title }}</b>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="questionEditDialog" :title="$t('components.registerForm.recursiveQuestion.editQuestion')" class="large" center append-to-body destroy-on-close>
      <QuestionEdit v-if="questionEditDialog" :question="editQuestion" :mainType="mainType" @saveEdit="saveEditQuestion" @closeDialog="questionEditDialog = false" @deleteMe="deleteQuestionOne" />
    </el-dialog>

    <el-dialog :title="$t('components.registerForm.recursiveQuestion.addQuestion')" :visible.sync="newQuestionDialog" class="large" center append-to-body destroy-on-close>
      <div id="addquestion-dialog" class="custom-modal">
        <div class="modal-body no-footer">
          <div class="add-question-container">
            <!-- <div class="question-list">
              <div class="title">Pre-defined questions</div>
              <div class="list">
                <div class="title">Photo</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(32)"></el-button>
              </div>
              <div class="list">
                <div class="title">Title</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(4)"></el-button>
              </div>
              <div class="list">
                <div class="title">Instituon</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(33)"></el-button>
              </div>
              <div class="list">
                <div class="title">Company</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(3)"></el-button>
              </div>
              <div class="list">
                <div class="title">Department</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(34)"></el-button>
              </div>
              <div class="list">
                <div class="title">School</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(5)"></el-button>
              </div>
              <div class="list">
                <div class="title">Mobile phone</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(26)"></el-button>
              </div>
              <div class="list">
                <div class="title">Work phone</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(27)"></el-button>
              </div>
              <div class="list">
                <div class="title">Country</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(8)"></el-button>
              </div>
              <div class="list">
                <div class="title">State</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(28)"></el-button>
              </div>
              <div class="list">
                <div class="title">City</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(9)"></el-button>
              </div>
              <div class="list">
                <div class="title">Postal code</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(29)"></el-button>
              </div>
              <div class="list">
                <div class="title">Address Line</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(30)"></el-button>
              </div>
              <div class="list">
                <div class="title">HES Kodu</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(31)"></el-button>
              </div>
            </div> -->
            <div class="question-list">
              <div class="title">{{ $t("components.registerForm.recursiveQuestion.customLineQuestion") }}</div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.singleLineText") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(10)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.multiLineText") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(11)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.email") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(12)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.phoneNumber") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(13)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.fileUpload") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(104)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.number") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(14)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.multipleChoiceQuestion") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(100)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.singleChoiceQuestion") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(15)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.selectDropdown") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(16)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.datePicker") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(101)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.timePicker") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(102)"></el-button>
              </div>
              <!-- <div class="list">
                <div class="title">{{$t('components.registerForm.recursiveQuestion.richTextEditor')}}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(103)"></el-button>
              </div> -->
            </div>
            <div class="question-list">
              <div class="title">{{ $t("components.registerForm.recursiveQuestion.informationQuestions") }}</div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.slider") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(202)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.rate") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(200)"></el-button>
              </div>
              <div class="list">
                <div class="title">{{ $t("components.registerForm.recursiveQuestion.emotionRate") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(201)"></el-button>
              </div>
              <div class="list">
                <div class="title" v-if="mainType != 7 && mainType != 4 && mainType != 2">{{ $t("components.registerForm.recursiveQuestion.infoBlock") }}</div>
                <el-button circle size="small" icon="fas fa-plus" type="primary" @click="getQuestionObject(500)"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import QuestionEdit from "./QuestionEdit.vue";
import MoneyInput from "./Inputs/MoneyInput.vue";
export default {
  data() {
    return {
      saveQuestionsTimeout: null,
      loading: false,
      newQuestionDialog: false,
      editDialog: false,
      lastFocus: false,
      timeout: null,
      questionEditDialog: false,
      editQuestion: {},
      lastOption: {
        type: null,
        parentAnswerId: null
      },
      activeIndex: null
    };
  },
  components: {
    draggable,
    QuestionEdit,
    MoneyInput
  },
  name: "RecursiveQuestion",
  watch: {
    saveStatus: function(newVal) {
      if (newVal == false) {
        this.activeIndex = null;
      }
    },
    lastFocus() {
      console.log(this.lastFocus);
      this.$store.dispatch("setLastFocus", this.lastFocus);
    }
  },
  props: ["question", "questions", "baseId", "mainType", "active", "saveStatus"],
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    },
    currentForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    currentQuestions() {
      return this.$store.getters.getCurrentQuestions;
    },
    getQuestionsValidation() {
      return this.$store.getters.getQuestionsValidation;
    },
    getLastFocusLoading() {
      return this.$store.getters.getLastFocusLoading;
    },

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    checkMove(e) {
      this.activeIndex = e.draggedContext.futureIndex;
    },
    deleteSubQuestion(id) {
      var newObj = this.currentQuestions.filter(x => x.parentAnswerId != id);
      this.$store.commit("setCurrentQuestions", newObj);
    },
    addNewQuestion(id) {
      this.lastOption.parentAnswerId = id;
      this.newQuestionDialog = true;
    },
    async copyQuestionOne(id) {
      this.loading = "copyItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("copyQuestionOne", id);
        if (!res.data.alert.hasError) {
          this.$message.success(res.data.alert.message);
          await this.$store.dispatch("getQuestionsObject", { type: this.question.mainType, id: this.baseId });
        } else {
          this.$message.error(res.data.alert.message);
        }
        this.loading = false;
      }, 500);
    },
    async deleteQuestionOne(id) {
      await this.$store.dispatch("deletQuestionOne", id);

      await this.$store.dispatch("getQuestionsObject", { type: this.question.mainType, id: this.baseId });
    },
    saveEditQuestion() {
      this.questionEditDialog = false;
    },
    openQuestionEditDialog(item) {
      this.editQuestion = item;
      this.questionEditDialog = true;
    },
    totalSub(item) {
      var total = 0;
      total += this.currentQuestions.filter(x => x.parentAnswerId == item).length;
      return total;
    },
    totalOptions(item) {
      var total = 0;
      this.currentQuestions
        .filter(x => x.parentAnswerId == item)
        .map(x => {
          total += x.options.length;
        });

      return total;
    },

    async AddOption() {
      var res = await this.$store.dispatch("getQuestionObject", {
        type: 15,
        mainType: 0,
        registrationFormId: this.baseId,
        parentAnswerId: null,
        parentQuestionId: this.question.id
      });
      this.question.options.push({
        id: res.options[0].id,
        title: "New Option"
      });
      ///
    },
    async getQuestionObject(type) {
      var res = await this.$store.dispatch("getQuestionObject", {
        type: type,
        mainType: this.question.mainType,
        registrationFormId: this.baseId,
        parentAnswerId: this.lastOption.parentAnswerId,
        parentQuestionId: this.question.id
      });

      ///
      this.currentQuestions.push(res);
    }
  }
};
</script>

<style lang="less">
.error-input {
  input {
    border: 1px solid red;
  }
}

.question-border {
  .el-collapse {
    border: 3px dashed #dedede !important;
    padding: 0px 10px !important;
    margin-bottom: 1rem;
    border-radius: 6px;
    position: relative;

    &::before {
      content: "";
      background-image: url("../../assets/images/recursive.svg");
      display: block;
      background-size: contain !important;
      background-position: center center !important;
      background-repeat: no-repeat !important;
      width: 30px;
      height: 30px;
      position: absolute;
      top: -21px;
      left: -35px;
    }

    .el-collapse-item__header {
      display: flex;
      gap: 1rem;
      align-items: center;
      .collapsed-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      & > .expand-container {
        display: block;
        flex-shrink: 0;
      }
      & > .collapse-container {
        display: none;
        flex-shrink: 0;
      }
      &.is-active {
        & > .expand-container {
          display: none;
        }
        & > .collapse-container {
          display: block;
          flex-shrink: 0;
        }
      }
    }
  }
}

.left-icon {
  &.movable {
    box-sizing: border-box;
    font-size: 20px;
    color: #505763;
    cursor: grab;
    opacity: 1;
  }
  box-sizing: border-box;
  font-size: 20px;
  color: #505763;
  opacity: 0.5;
  cursor: not-allowed;
}

.question-q {
  .el-checkbox {
    margin: 0;
  }

  &.passive {
    background-color: #fff2f2;
  }

  &.disabled {
    .left-icon {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .question-head-2 {
    display: flex;
    gap: 1rem;
    align-items: center;
    & > .error-container {
      width: 100%;
    }
  }
  padding: 10px;
  background-color: #f3f3f3;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1fr 180px 90px 90px 90px;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.5rem;
  &.poll {
    grid-template-columns: 1fr !important;
  }
}
.question-q-3 {
  & > .question-head-2 {
    flex-grow: 1;
    display: flex;
    gap: 1rem;
    width: 100%;
    align-items: center;
    .el-input {
      input {
        width: 100%;
      }
    }
  }
  padding: 10px;
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.question-border {
  //   border: 1px solid black;
  margin-bottom: 0.5rem;
}
.question-q-2 {
  //   padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.question-type {
  font-weight: bold;
}

.addQuestionButtonRow {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  padding-top: 20px;
  width: 100%;
  border-top: 1px solid #ddd;

  button {
    margin-right: 8px;
  }
}

.addOptionButtonRow {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;

  button {
    margin-right: 8px;
  }
}
.question-head-btn {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  .el-button {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/RecursiveQuestion.vue